module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/259-european-union-22a09d5f87bba1359c1ddb8800ac6973.svg";